//useselector will directly point to the state we wnat  

//import Name and input at app.js 
import React from 'react'
import { useSelector } from 'react-redux';

//were printing the stuff user inputs, by first retreiving it from the reduxstore 
const Name = () => {
  const firstName = useSelector(state => state.firstName);
  const lastName  = useSelector(state => state.lastName);  

  return <h1>Name: {firstName} {lastName}</h1>;
}

export default Name